import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from 'react-toastify';
import logo from "../images/logo.svg";
import { useForgotPasswordMutation } from '../redux/services/authApi';

export default function ForgotPassword() {

    const [ email, setEmail ] = useState('')
    const [ forgotPassword, { isLoading } ] = useForgotPasswordMutation()
    const navigate = useNavigate()
    
    let handleInput = (e) => {
        switch (e.target.id) {
            case 'email':
            setEmail(e.target.value);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    const sendOTP = async (e) => {
        e.preventDefault()

        await forgotPassword({ email })
            .unwrap()
            .then((resp) => {
                toast.success(resp?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                navigate("/reset-password", { state: {email} })
            })
            .catch((error) => {
                toast.error(error?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                console.log('err', error)}
            )
    }


 

    return (
        <>
            <section className="row">
                <section className="col-md-6 p-md-5 pull-up">
                    <div className="w-75 mx-auto  my-md-0 my-4">
                        <div className="logo">
                            <img src={logo} alt="logo" />
                            <span className="logo-txt">Flash</span>
                        </div>
                        <div>
                            <h1 className="auth-title mb-5">Forgot Password</h1>
                            <form>
                                <div className="form-group mb-4">
                                    <label htmlFor="email" className="font-weight-bold mb-2">Email Address</label>
                                    <div className="input form-control border-secondary">
                                        <i className="ri-mail-line ri-lg px-2 w-25"></i> 
                                        <input type="email" onChange={handleInput} value={email} id="email" placeholder="Email Address" className="w-80 p-2 ps-0" />
                                    </div>
                                </div>

                                <button className="submit-btn mt-3 p-3 form-control flash-bg text-uppercase fw-bold" onClick={sendOTP}>
                                    {isLoading ? <ClipLoader size={20} /> : "Send otp"}
                                </button>
                            </form>
                        </div>
                    </div>
                </section>
                <section className="col-md-6 px-0 d-none auth-side-img d-md-block"></section>
            </section>
        </>
    )
}